module.exports = __webpack_public_path__ + "static/media/buzz.056b00c9.mp3";